import React, {useEffect, useState} from 'react'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import {getPaneliDrzaveDropdown} from '../../api/drzava'
import {Option} from '../../models/BojaModel'

interface DropdownProps {
  value?: string | number
  initialValue?: string | number
  onChange?: (name: string, value: any) => void
  errors?: string | undefined
  touched?: boolean
  selectName?: string
}

const mapDropdown = (data) => {
  if (!data) {
    return []
  }

  return data.map((item) => ({label: item, value: item}))
}

const DrzavaDropdownPaneli: React.FC<DropdownProps> = ({
  value,
  initialValue,
  onChange,
  errors,
  touched,
  selectName,
}) => {
  const [drzavaDropdown, setDrzavaDropdown] = useState<Array<Option>>([])
  const [internalValue] = useState<string | number | null>(initialValue ?? null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getPaneliDrzaveDropdown()
        setDrzavaDropdown(mapDropdown(response.data))
      } catch (error) {
        console.error('Error fetching paneli drzava dropdown data:', error)
      }
    }

    fetchData()
  }, [])

  const finalValue = typeof value !== 'undefined' ? value : internalValue

  return (
    <SearchableSelect
      options={drzavaDropdown}
      value={finalValue?.toString() ?? ''}
      onChange={onChange!}
      name={selectName ?? 'Drzava'}
      errors={errors}
      placeholder='Odaberi drzavu...'
      touched={touched}
    />
  )
}

export default DrzavaDropdownPaneli
